import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   translate: 'MENU.DASHBOARD.COLLAPSIBLE',
  //   type: 'collapsible',
  //   role: ['Admin'],
  //   icon: 'home',
  //   // badge: {
  //   //   title: '3',
  //   //   translate: 'MENU.DASHBOARD.BADGE',
  //   //   classes: 'badge-light-warning badge-pill'
  //   // },
  //   children: [
  //     {
  //       id: 'analytics',
  //       title: 'Over All',
  //       translate: 'MENU.DASHBOARD.ANALYTICS',
  //       type: 'item',
  //       role: ['Admin'], //? To set multiple role: ['Admin', 'Client']
  //       icon: 'circle',
  //       url: 'application/dashboard/analytics'
  //     },
   
  //   ]
  // },

  // {
  //   id: 'others',
  //   type: 'section',
  //   title: 'Others',
  //   translate: 'MENU.APPS.SECTION',
  //   icon: 'box',
  //   children: [
  //     {
  //       id: 'menu-levels',
  //       title: 'Menu Levels',
  //       translate: 'MENU.APPS.SECTION',
  //       icon: 'menu',
  //       type: 'collapsible',
  //     }
  //   ]
  // },
  {
    id: 'appPolicies',
    type: 'section',
    title: 'Policies',
    role: ['Basic'],
    icon: 'package',
    children: [
      {
        id: 'appPoliciesHR',
        title: 'Human Resource',
        type: 'collapsible',
        icon: 'folder',
        role: ['Basic'],
       children: [
        {
          id: 'appPoliciesHREmployeeHandout',
          title: 'Employee Handout',
          icon: 'file',
          type: 'item',
          url: 'application/policies/hr',
        },
          
        ]
      }
    ]
  },

  {
    id: 'apps2',
    type: 'section',
    title: 'ICT Department',
    role: ['EPICT'],
    icon: 'package',
    children: [
      {
        id: 'itsm',
        title: 'ITSM',
        type: 'collapsible',
        icon: 'award',
        role: ['EPICTITSMADMIN','EPICT'],
        //url: 'ict/itsm/dashboard',
       children: [
        {
          id: 'itsm-dashboard',
          title: 'Dashboard',
          icon: 'activity',
          type: 'item',
          url: 'application/ict/itsm/dashboard',
        },
        {
          id: 'itsm-personnelstatus',
          title: 'Status',
          icon: 'feather',
          type: 'item',
          url: 'application/ict/itsm/personnel/status',
        },
        {
          id: 'itsm-team',
          title: 'Team',
          icon: 'users',
          type: 'item',
          role: ['EPICTITSMADMIN'],
          url: 'application/ict/itsm/team',
        },
        {
          id: 'itsm-ticket',
          title: 'Tasks',
          icon: 'trello',
          type: 'item',
          role: ['EPICT'],
          url: 'application/ict/itsm/ticket',
        },
          {
            id: 'itsm-setup',
            title: 'Setup',
            icon: 'tool',
            role: ['EPICTITSMADMIN'],
            type: 'collapsible',
            children: [
              {
                id: 'itsm-roles',
                title: 'Roles',
                icon: 'circle',
                type: 'item',
                role: ['EPICTITSMADMIN'],
                url: 'application/ict/itsm/setup/role',
              },
              {
                id: 'itsm-member-status',
                title: 'Member Status',
                icon: 'circle',
                type: 'item',
                role: ['EPICTITSMADMIN'],
                url: 'application/ict/itsm/setup/member-status',
              },
              {
                id: 'itsm-ticket-status',
                title: 'Ticket Status',
                icon: 'circle',
                type: 'item',
                role: ['EPICTITSMADMIN'],
                url: 'application/ict/itsm/setup/ticket-status',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'apps3',
    type: 'section',
    title: 'APPLICATION',
    role: ['Basic'],
    icon: 'package',
    children: [
      {
        id: 'itsm',
        title: 'Payroll',
        type: 'collapsible',
        icon: 'file-text',
        role: ['Basic','ForIncubation'],
        //url: 'ict/itsm/dashboard',
       children: [
        // {
        //   id: 'itsm-dashboard',
        //   title: 'Dashboard',
        //   icon: 'activity',
        //   type: 'item',
        //   url: 'application/ict/itsm/dashboard',
        // },
        {
          id: 'payroll',
          title: 'Payslip Viewer',
          translate: 'MENU.PAYSLIP',
          type: 'item',
          icon: 'file-text',
          role: ['Basic','Moderator','EPICT'],
          url: 'application/payslip-viewer',
        },
        {
          id: 'digital-form',
          title: 'Digital Form',
          translate: 'MENU.DIGITALFORM',
          type: 'item',
          icon: 'list',
          role: ['ForIncubation'],
          url: 'application/digital-form',
        },		
		
        // {
        //   id: 'email',
        //   title: 'Report',
        //   translate: 'MENU.REPORTS',
        //   type: 'item',
        //   icon: 'list',
        //   //role: ['Admin','Moderator'],
        //   url: 'application/report',
        // },
        ]
      }
    ]
  },

  
  // {
  //   id: 'apps',
  //   type: 'section',
  //   title: 'Apps & Pages',
  //   //translate: 'MENU.APPS.SECTION',
  //   role: ['Basic'],
  //   icon: 'package',
  //   children: [
  //     {
  //       id: 'payroll',
  //       title: 'Payslip Viewer',
  //       translate: 'MENU.PAYSLIP',
  //       type: 'item',
  //       icon: 'file-text',
  //       role: ['Admin','Moderator'],
  //       url: 'application/payslip-viewer',
  //     },
  //     {
  //       id: 'email',
  //       title: 'My Tasks',
  //       translate: 'MENU.MYTASKS',
  //       type: 'item',
  //       icon: 'award',
  //       role: ['Admin','Moderator'],
  //       url: 'application/my-tasks',
  //     },
  //     {
  //       id: 'email',
  //       title: 'Report',
  //       translate: 'MENU.REPORTS',
  //       type: 'item',
  //       icon: 'list',
  //       //role: ['Admin','Moderator'],
  //       url: 'application/report',
  //     },

  //     // {
  //     //   id: 'chat',
  //     //   title: 'My Request',
  //     //   translate: 'MENU.REPORTS',
  //     //   type: 'item',
  //     //   icon: 'file-text',
  //     //   role: ['Admin'],
  //     //   url: 'sample'
  //     // },
  //     // {
  //     //   id: 'todo',
  //     //   title: 'My Department',
  //     //   translate: 'MENU.REPORTS',
  //     //   type: 'item',
  //     //   icon: 'check-square',
  //     //   role: ['Admin'],
  //     //   url: 'apps/todo'
  //     // },
  //   ]
  // },
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   translate: 'MENU.HOME',
  //   type: 'item',
  //   icon: 'home',
  //   url: 'application/dashboard',
  //   role: ['Admin'],

  // },
  {
    id: 'report',
    title: 'Report',
    translate: 'MENU.REPORTS',
    type: 'item',
    icon: 'file',
    url: 'application/report',
    role: ['Basic'],

  },
  {
    id: 'document-approval',
    title: 'Document Approval',
    translate: 'MENU.DOCUMENTAPPROVAL',
    type: 'item',
    icon: 'check-square',
    url: 'application/document-approval',
    role: ['DocumentApprover'],

  },
  // {
  //   id: 'apps4',
  //   type: 'section',
  //   title: 'ADMINISTRATOR',
  //   role: ['DocumentApprover'],
  //   icon: 'package',
  //   children: [
  //     {
  //       id: 'admin',
  //       title: 'Digital Form',
  //       type: 'collapsible',
  //       icon: 'file-text',
  //       role: ['DocumentApprover'],
  //       //url: 'ict/itsm/dashboard',
  //      children: [
  //       // {
  //       //   id: 'itsm-dashboard',
  //       //   title: 'Dashboard',
  //       //   icon: 'activity',
  //       //   type: 'item',
  //       //   url: 'application/ict/itsm/dashboard',
  //       // },
  //       {
  //         id: 'administrator',
  //         title: 'Leave Generation',
  //         translate: 'MENU.LEAVEGENERATION',
  //         type: 'item',
  //         icon: 'settings',
  //         url: 'application/administrator/admin-leave-generation',
  //         role: ['DocumentApprover'],
      
  //       },		
  //       // {
  //       //   id: 'email',
  //       //   title: 'Report',
  //       //   translate: 'MENU.REPORTS',
  //       //   type: 'item',
  //       //   icon: 'list',
  //       //   //role: ['Admin','Moderator'],
  //       //   url: 'application/report',
  //       // },
  //       ]
  //     }
  //   ]
  // },
  
  // {
  //   id: 'home',
  //   title: 'Home',
  //   translate: 'MENU.HOME',
  //   type: 'item',
  //   icon: 'home',
  //   url: 'home',
  //   role: ['Basic']
  // },
  // {
  //   id: 'purchases',
  //   title: 'Purchases',
  //   translate: 'MENU.PURCHASES',
  //   type: 'item',
  //   icon: 'shopping-bag',
  //   url: 'purchases',
  //   role: ['Basic']
  // },
  // {
  //   id: 'shareCapital',
  //   title: 'Share Capital',
  //   translate: 'MENU.SHARE_CAPITAL',
  //   type: 'item',
  //   icon: 'trending-up',
  //   url: 'share-capital',
  //   role: ['Basic']
  // },
  // {
  //   id: 'contactUs',
  //   title: 'Contact Us',
  //   translate: 'MENU.CONTACT_US',
  //   type: 'item',
  //   icon: 'phone',
  //   url: 'contact-us',
  //   role: ['Basic']
  // },
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   translate: 'MENU.DASHBOARD',
  //   type: 'item',
  //   icon: 'home',
  //   url: 'admin/dashboard',
  //   role: ['Admin'],
  // },
  // {
  //   id: 'applicant',
  //   title: 'Applicants',
  //   translate: 'MENU.APPLICANTS',
  //   type: 'item',
  //   icon: 'user-plus',
  //   url: 'admin/applicants',
  //   role: ['Admin'],
  // },
  // {
  //   id: 'member',
  //   title: 'Members',
  //   translate: 'MENU.MEMBERS',
  //   type: 'item',
  //   icon: 'users',
  //   url: 'admin/members',
  //   role: ['Admin'],
  // },
  // {
  //   id: 'events',
  //   title: 'Events',
  //   translate: 'MENU.EVENTS',
  //   type: 'item',
  //   icon: 'calendar',
  //   url: 'admin/events',
  //   role: ['Admin'],
  // },
  // {
  //   id: 'announcements',
  //   title: 'Announcements',
  //   translate: 'MENU.ANNOUNCEMENTS',
  //   type: 'item',
  //   icon: 'bell',
  //   url: 'admin/announcements',
  //   role: ['Admin'],
  // },
  // {
  //   id: 'setup',
  //   title: 'Setup',
  //   translate: 'MENU.SETUP',
  //   type: 'collapsible',
  //   icon: 'tool',
  //   role: ['Admin'],
  //   children: [
  //     {
  //       id: 'membershipRequirements',
  //       title: 'Requirements',
  //       type: 'item',
  //       url: 'admin/setup/membership-requirements',
  //     }
  //   ]
  // },
  
  // {
  //   id: 'settings',
  //   title: 'Settings',
  //   translate: 'MENU.SETTINGS',
  //   type: 'collapsible',
  //   role: ['Basic', 'Admin'],
  //   icon: 'settings',
  //   children: [
  //   ]
  // },
]
